import { Pipe, PipeTransform } from '@angular/core';
import { LanguageService } from './language.service';
import { TranslationKey } from './translations/en';

@Pipe({
  name: 't',
  standalone: true,
  pure: false
})
export class TranslatePipe implements PipeTransform {
  constructor(private readonly i18n: LanguageService) {}

  transform(key: TranslationKey, params?: Record<string, string | number>): string {
    return this.i18n.t(key, params);
  }
}
